<template>
  <ModalBase @closed="emit('closed')" :closeBtn="true" :full="true">
    <div class="wrapper">
      <HtmlContent class="article" :html="data.text" />
    </div>
  </ModalBase>
</template>

<script setup>
const emit = defineEmits(["closed"]);
const { data } = await useFetch("/api/policy");
</script>
